import { BasePaginatorDto } from '@diritto/common/base/paginator/paginator.dto';
import { EpisodeOrderType } from '@diritto/common/episode/constants';
import { ContentEpisodesRelayResponseDto } from '@diritto/common/relay/dtos/episode-relay.dtos';
import { Http } from '@diritto/common/utils/requester/http';

export class RelayEpisodeApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getContentEpisodes(
    contentId: number,
    orderType: EpisodeOrderType,
    paginator: BasePaginatorDto,
  ): Promise<ContentEpisodesRelayResponseDto> {
    const res = await this.http.get<ContentEpisodesRelayResponseDto>(
      `${this.url}/relay/contents/${contentId}/episodes`,
      {
        params: { ...paginator, orderType },
      },
    );
    return res.data;
  }

  async getContentNotices(
    contentId: number,
    orderType: EpisodeOrderType,
    paginator: BasePaginatorDto,
  ): Promise<ContentEpisodesRelayResponseDto> {
    const res = await this.http.get<ContentEpisodesRelayResponseDto>(
      `${this.url}/relay/contents/${contentId}/notices`,
      {
        params: { ...paginator, orderType },
      },
    );
    return res.data;
  }
}
